import { styled } from '@aibi-ui/core';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UserInfo from './views/UserInfo';
import ChartPreview from '../ChartList/components/ChartPreview/ChartPreview';
import ChartView from './views/ChartView';
import DashboardView from './views/DashboardView';
import ChatView from './views/ChatView';
import RecentView from './views/RecentView';
import isMobile from '../../utils/isMobile';

const HomeStyled = styled.div`
  height: calc(100vh - 55px);
  background: #f6f7f9;
  .header {
    display: flex;
    align-items: center;
    padding-left: 16px;
    height: 55px;
    color: #333;
    font-size: 16px;
    font-weight: 600;
    background: #fff;
  }
  .banner-wrapper {
    padding: 12px;
    height: calc(100% - 55px);
  }
  .banner-1,
  .banner-2 {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .banner-1 {
    height: 476px;
    .banner-1-left,
    .banner-1-right {
      height: 100%;
    }
    .banner-1-left {
      width: 468px;
    }
    .banner-1-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
      .module {
        height: calc(50% - 4px);
      }
    }
  }
  .banner-2 {
    margin-top: 8px;
    height: calc(100% - 476px - 4px);
    min-height: 234px;
    .module {
      width: 50%;
    }
  }
`;

const Home = () => {
  const user = useSelector(state => state.user);
  const [showChartPreview, setShowChartPreview] = useState(false);
  const [sliceId, setSliceId] = useState(null);

  const mobile = isMobile();
  useEffect(() => {
    if (mobile) {
      const searchParams = window.location.search;
      window.location.href = `/mobile/chat${searchParams}`;
    }
  }, []);
  return (
    <HomeStyled>
      <div className="header">首页</div>
      <div className="banner-wrapper">
        <div className="banner-1">
          <div className="banner-1-left">
            <UserInfo user={user} />
          </div>
          <div className="banner-1-right">
            <div className="module">
              <RecentView
                user={user}
                setShowChartPreview={setShowChartPreview}
                setSliceId={setSliceId}
              />
            </div>
            <div className="module">
              <ChatView user={user} />
            </div>
          </div>
        </div>
        <div className="banner-2">
          <div className="module">
            <DashboardView user={user} />
          </div>
          <div className="module">
            <ChartView
              setShowChartPreview={setShowChartPreview}
              setSliceId={setSliceId}
            />
          </div>
        </div>
      </div>
      <ChartPreview
        showModal={showChartPreview}
        setShowModal={setShowChartPreview}
        sliceId={sliceId}
      />
    </HomeStyled>
  );
};

export default Home;
